import { Button } from "react-bootstrap";
import CategoryList from "./CategoryList";
import EquipmentUnitCategoryJsonView from "./EquipmentUnitCategoryJsonView";
import { Link, useHistory } from 'react-router-dom';
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { CLEAR_PERSISTED_CATEGORY_DATA } from "../../../../store/actions";

const EquipmentUnitCategories = () => {

    const history = useHistory();
    const profileId = history.location.pathname?.split("/")?.[2];
    const dispatch = useDispatch();

    const checkIfUserInGlobalCategoriesPage = () => history?.location?.pathname?.split("/").includes('global');

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_PERSISTED_CATEGORY_DATA });
        }
    }, []);

    return (
        <>
            {
                !checkIfUserInGlobalCategoriesPage() &&
                    <Link to={{ pathname: `/profile/${profileId}` }}>
                        <Button style={{ fontWeight: 'bold' }} size="sm">Go back to profile</Button>
                    </Link>
            }
            <div style={{ marginTop: "15px" }} className="category-management-container">
                <CategoryList profileId={profileId} checkIfUserInGlobalCategoriesPage={() => checkIfUserInGlobalCategoriesPage()} />
                <EquipmentUnitCategoryJsonView />
            </div>
        </>
    );
}

export default EquipmentUnitCategories;